<template>
<div>
  <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
          <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
  </div>
  <div v-if="loading_page === false">
    <div class="all_menu_user_manual">
      <v-card class="list_menu_user_manual">
        <div @click="stream_pdf(`${publicPath}User_manual_full_service_ZoftConnect.pdf`)" class="menu_card_user_manual d-flex flex-column justify-center align-center">
          <div class="img_menu_user_manual">
            <img src="@/assets/icon_food_store.png">
          </div>
          <div class="title_menu_user_manual">
            ร้านอาหาร (Full Service)
          </div>
        </div>
      </v-card>
      <v-card class="list_menu_user_manual">
        <div @click="stream_pdf(`${publicPath}User_manual_sales_ZoftConnect.pdf`)" class="menu_card_user_manual d-flex flex-column justify-center align-center">
          <div class="img_menu_user_manual">
            <img src="@/assets/icon_manual_sale.png">
          </div>
          <div class="title_menu_user_manual">
            ยอดขาย
          </div>
        </div>
      </v-card>
      <v-card class="list_menu_user_manual">
        <div @click="stream_pdf(`${publicPath}User_manual_team_ZoftConnect.pdf`)" class="menu_card_user_manual d-flex flex-column justify-center align-center">
          <div class="img_menu_user_manual">
            <img src="@/assets/icon_manual_team.png">
          </div>
          <div class="title_menu_user_manual">
            ทีมงาน
          </div>
        </div>
      </v-card>
      <v-card class="list_menu_user_manual">
        <div @click="stream_pdf(`${publicPath}User_manual_stock_ZoftConnect.pdf`)" class="menu_card_user_manual d-flex flex-column justify-center align-center">
          <div class="img_menu_user_manual">
            <img src="@/assets/icon_manual_stock.png">
          </div>
          <div class="title_menu_user_manual">
            คลัง
          </div>
        </div>
      </v-card>
      <v-card class="list_menu_user_manual">
        <div @click="stream_pdf(`${publicPath}User_manual_profile_ZoftConnect.pdf`)" class="menu_card_user_manual d-flex flex-column justify-center align-center">
          <div class="img_menu_user_manual">
            <img src="@/assets/icon_manual_profile.png">
          </div>
          <div class="title_menu_user_manual">
            ข้อมูลส่วนตัว
          </div>
        </div>
      </v-card>
    </div>
  </div>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
export default {
  name: "UserManualMenu",
  inject: {
      theme: {
          default: {
              isDark: false
          },
      },
  },
  data(){
    return {
      loading_page: true,
      publicPath: process.env.BASE_URL,
    }
  },
  methods: {
    async buffetList() {
        this.loading_page = true
        HTTP.get('/buffet/list', {
                headers: {
                    "Authorization": `Bearer ${this.$store.state.token}`
                }
            })
            .then((response) => {
                if (response.data.successful === true) {
                    this.loading_page = false
                }

            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
    },
    stream_pdf(link) {
      window.open(link, '_blank')
    },
  },
  mounted() {
      this.buffetList()
  }
}
</script>

<style scoped>
.list_menu_user_manual {
  padding: 15px;
}

.list_menu_user_manual:nth-child(odd) {
  margin-right: 4px;
}

.list_menu_user_manual:nth-child(even) {
  margin-left: 4px;
}

.list_menu_user_manual:hover {
  background: linear-gradient(to top, #038cc1 , #55c0e9)!important;
  transition: 0.1s !important;
}

.list_menu_user_manual:hover>.menu_card_user_manual {
  color: #fff !important;
}

.list_menu_user_manual_none {
  width: 50%;
  padding: 15px;
  margin-left: 5px;
}

.menu_card_user_manual {
  text-decoration: none;
  color: rgba(0, 0, 0, 0.87) !important;
  cursor: pointer;
}

.img_menu_user_manual {
  width: 100px;
}

.img_menu_user_manual>img {
  max-width: 100%;
}

.title_menu_user_manual {
  font-size: 20px;
}
.all_menu_user_manual {
  display:grid;
  grid-template-columns: 50% 50%;
  grid-row-gap: 8px;
}
</style>
